import { purify } from '@vfit/shared/themes';
import { Children } from 'react';
import {
  AllowanceDivider,
  AllowancePlus,
  AllowanceHR,
  FirstLabelContainer,
  LabelsContainer,
  OfferAllowanceLabel,
  Wrapper,
} from './productCardTopContainer.style';
import { IProductCardTopContainer } from './productCardTopContainer.models';
import PriceLite from '../../../PriceLite/priceLite';

const ProductCardTopContainer = ({
  offerAllowanceLabel,
  price,
  recurrence,
  originalPrice,
  priceTitle,
}: IProductCardTopContainer) => {
  const purifiedLabels = purify(offerAllowanceLabel);
  const slicedLabels = purifiedLabels.slice(1);

  return (
    <Wrapper>
      <FirstLabelContainer>
        <OfferAllowanceLabel
          dangerouslySetInnerHTML={{ __html: purifiedLabels[0]?.toUpperCase() || '' }}
        />
        <PriceLite
          price={price}
          originalPrice={originalPrice}
          recurrence={recurrence}
          priceLabel={priceTitle}
        />
      </FirstLabelContainer>
      {slicedLabels.length > 0 && (
        <LabelsContainer>
          {Children.toArray(
            slicedLabels.map((slicedLabel) => (
              <>
                <AllowanceDivider>
                  <AllowanceHR />
                  <AllowancePlus>+</AllowancePlus>
                  <AllowanceHR />
                </AllowanceDivider>
                <OfferAllowanceLabel
                  dangerouslySetInnerHTML={{ __html: slicedLabel?.toUpperCase() || '' }}
                />
              </>
            ))
          )}
        </LabelsContainer>
      )}
    </Wrapper>
  );
};

export default ProductCardTopContainer;
